import React from 'react'

let styleCenter = {
  margin: '0 auto',
  float: 'none'
}

const CircleDate = ({cardDate, color, fontColor}) => {
  if (!fontColor) {
    fontColor = 'white'
  }
  return (
    <div style={styleCenter}>
      <div className='text-center circle-style' style={{backgroundColor: color, color: fontColor}}>{cardDate}</div>
    </div>
  )
}

export default CircleDate



// WEBPACK FOOTER //
// ./src/components/history/circle-date.jsx